<template>
  <v-card flat>
    <v-card-title class="pt-0 px-0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            @click="modal = true"
          >
            {{ mdiTable }}
          </v-icon>
        </template>
        <span>Open tension beats table</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            @click="chart = true"
          >
            {{ mdiChartBar }}
          </v-icon>
        </template>
        <span>Open tension beats chart</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text v-if="loading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-card-text>
    <v-card-text class="pa-0" v-else>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">
                Avg per Session
              </th>
              <th class="text-left">
                Avg per Event
              </th>
              <th class="text-left">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="items.length === 0">
              <td class="text-center caption" colspan="4">No data</td>
            </tr>
            <template v-else>
              <tr
                v-for="item in items"
                :key="item.name"
              >
                <td class="caption">{{ item.name }}</td>
                <td class="caption">{{ (item.val / (item.players || 1)).toFixed(2) }}</td>
                <td class="caption">{{ (item.val / (item.events || 1)).toFixed(2) }}</td>
                <td class="caption">{{ item.val }}</td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <drops-by-tension-beats-modal
      v-if="modal"
      @close="modal = false"
    />
    <chart-by-tension-beats-data
      v-if="chart"
      title="Drop by Tension Beats"
      link="marketing/telemetry/global-drop/tension-beats/chart"
      @close="chart = false"
    />
  </v-card>
</template>

<script>
import { mdiTable, mdiChartBar } from '@mdi/js';
export default {
  components: {
    dropsByTensionBeatsModal: () => import('./dropsByTensionBeatsModal.vue'),
    chartByTensionBeatsData: () => import('../chartByTensionBeatsData.vue')
  },
  data () {
    return {
      mdiTable,
      mdiChartBar,
      loading: true,
      items: [],
      modal: false,
      chart: false
    }
  },
  watch: {
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-drop`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.items = data
      }
      this.loading = false
    }
  }
}
</script>